// removed by extract-text-webpack-plugin
module.exports = {"react-django-template":"LinkButton__react-django-template___-hash--base64-5-"};


/*****************
 ** WEBPACK FOOTER
 ** ./src/components/LinkButton/LinkButton.scss
 ** module id = 920
 ** module chunks = 1
 **/